package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initNov22022StrAuberryJawIllustrationChallengePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/nov22022StrAuberryJawIllustrationChallenge.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/nov22022-str-auberry-jaw-illustration-challenge")
@Composable
fun Nov22022StrAuberryJawIllustrationChallengePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("nov-2-2022-straiberry-jaw-illustration-challenge") }) {
        org.jetbrains.compose.web.dom.Text("nov-2-2022-StrAIberry-jaw-illustration-challenge")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In an inner part of our checkup system we had this section where user could select which tooth needs more attention in the detection process. We had this design of an illustration of human jaw. The design was really good. Each tooth on the design should have been selectable by user. The challenge was making the design responsive, each tooth should stay in place when screen size was changing and in android we have this verity of screens unlike ios.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The design was simple, we had two overall shape for upper and lower jaw. on the teeth side we had 8 teeth. Why 8? Imagine the left side of your lower jaw, it has 8 tooth, now the right side is exactly the same but the tooth are mirroring. so in the design system we only needed 8 tooth, then inside the code we mirror them when needed.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The base challenge was to place the tooth around the jaw shape. The jaw shape had this oval kind of shape. At the time Android had this cool component called ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("ConstraineLayout")
        }
        org.jetbrains.compose.web.dom.Text(". The component had values for bias, It had values for ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("horizontal_bias")
        }
        org.jetbrains.compose.web.dom.Text(" & ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("vertical_bias")
        }
        org.jetbrains.compose.web.dom.Text(" plus you could add padding. You can place a view in a circular position around another view.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Using ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("ConstraineLayout")
        }
        org.jetbrains.compose.web.dom.Text(" was a good help. The result was exactly like our designs and it was also responsive. But somthing that botherd me was our xml layout code was really big. we had to create an ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("imageView")
        }
        org.jetbrains.compose.web.dom.Text(" for each tooth and calculate the bias manually. Maybe we could refactor this in near future.")
    }
}
